import { hybridApi } from './hybridApi.ts';
import { setupAutoSync } from './syncService.ts';
import { startBackendMonitoring } from '../utils/backendStatus.ts';

// Always use hybrid mode - auto-detects online/offline and syncs automatically
// If no auth token, falls back to local IndexedDB
// If online with auth, uses server and syncs to local
export const api = hybridApi;

// Setup auto-sync and backend monitoring when app loads
if (typeof window !== 'undefined') {
  // Iniciar monitoramento do backend
  startBackendMonitoring();
  // Setup auto-sync
  setupAutoSync();
}
